import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
    userScore: 0,
    userCorrectAnswer: 0,
    userWrongAnswer: 0,
    correctQuestions: [],
    wrongQuestions: [],
    answerChoosed: [],
};

const userPlayerSlice = createSlice({
    name: "userPlayerSlice",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            return state;
        },
        resetUserScore: (state, action) => {
            state.userScore = 0;
            state.userCorrectAnswer = 0;
            state.correctQuestions = [];
            state.userWrongAnswer = 0;
            state.wrongQuestions = [];
            state.answerChoosed = [];
            return state;
        },
        userScoreUpdate: (state, action) => {
            state.userScore = state.userScore + action.payload;
            return state;
        },

        increaseCorrectAnswer: (state, action) => {
            state.userCorrectAnswer = state.userCorrectAnswer + 1;
            state.correctQuestions = [...state.correctQuestions, action.payload];
            return state;
        },
        increaseWrongAnswer: (state, action) => {
            state.userWrongAnswer = state.userWrongAnswer + 1;
            state.wrongQuestions = [...state.wrongQuestions, action.payload.question];
            state.answerChoosed = [...state.answerChoosed, action.payload.yourAnswer];
            return state;
        },
    },
});

export const {
    setUser,
    resetUserScore,
    userScoreUpdate,
    increaseCorrectAnswer,
    increaseWrongAnswer,
} = userPlayerSlice.actions;
export default userPlayerSlice;
